exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2_ZpkRoBa5ziCSXKruXclz {\n  text-decoration: none;\n}\n", ""]);
// Exports
exports.locals = {
	"remove-underline": "_2_ZpkRoBa5ziCSXKruXclz"
};